import React, { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

interface EditablePluginProps {
  isEditable: boolean
}

export const EditablePlugin: React.FC<EditablePluginProps> = ({ isEditable }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    editor.setEditable(isEditable)
  }, [editor, isEditable])

  return null
}
